/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
    ADD_OVERTIME(state, item) {
        state.employeeFiledOvertime.unshift(item)
    },
    UPDATE_OVERTIME(state, item) {
        const index = state.employeeFiledOvertime.findIndex((e) => e.employeeFiledOvertimeId === item.employeeFiledOvertimeId)
        Object.assign(state.employeeFiledOvertime[index], {
            otDate:item.otDate,
            fromTime:item.fromTime,
            toTime:item.toTime,
            noOfHours:item.noOfHours,
            reason:item.reason,
            isDraft:item.isDraft,
            isSubmitted:item.isSubmitted,
            submittedOn:item.submittedOn,
            isCancelled:item.isCancelled,
            cancelledOn:item.cancelledOn,
            remarks:item.remarks,
            fileId:item.fileId,
            subscriptionId:item.subscriptionId,
            approversOTs:item.approversOTs

        })
    },
    GET_ALL_OVERTIME(state, payload) {
        state.employeeFiledOvertime = payload

        //console.log(state.employeeFiledOvertime)
    },
    GET_ALL_OVERTIMETYPE(state, overtimeType) {
        state.overtimeTypes = overtimeType
    },
    UPLOAD_PHOTO(state, photo){
        state.photoUpload.unshift(photo)
    },
    GET_ALL_APPROVERS(state, approvers){
        state.approvers = approvers
    },
    UNSUBMIT_OVERTIME(state, overtimeId){
        //console.log('okay')
        //console.log(overtimeId)
        const index = state.employeeFiledOvertime.findIndex((e) => e.employeeFiledOvertimeId === overtimeId)
        Object.assign(state.employeeFiledOvertime[index], {isDraft: true, isSubmitted: false})
        
        
    },
    CANCELLED_OVERTIME(state, items){
        const index = state.employeeFiledOvertime.findIndex((e) => e.employeeFiledOvertimeId === items.employeeFiledOvertimeId)
        Object.assign(state.employeeFiledOvertime[index], {isDraft: items.isDraft, 
            isSubmitted: items.isSubmitted, 
            isCancelled: items.isCancelled, 
            remarks: items.remarks})
            
        state.employeeFiledOvertime[index].approversOTs.forEach((x) => {
            x.isRevised = items.isRevised
        })
        // const index =  state.employeeFiledOvertime[index].approvers.findIndex((e) => e.employeeFiledOvertimeId === items.employeeFiledOvertimeId)
    },
    RETRACKED_OVERTIME(state, items){
        const index = state.employeeFiledOvertime.findIndex((e) => e.employeeFiledOvertimeId === items.employeeFiledOvertimeId)
        Object.assign(state.employeeFiledOvertime[index], {isDraft: items.isDraft,
            isRetracted : items.isRetracted,
            retractedOn : items.retractedOn, 
            remarks: items.remarks})

        const app = state.employeeFiledOvertime[index].approversOT.filter((a) => a.employeeFiledLeaveId === items.employeeFiledLeaveId)
        console.log(app)
        app.forEach(idx => {
            console.log(idx)
            Object.assign(idx, {
                isApproved : false 
            })
        })

        // const a = state.employeeFiledOvertime[index].approversOTs.findIndex((a) => a.approverId === items.approverId)
        // Object.assign(state.employeeFiledOvertime[index].approversOTs[a], {
        //     isRetracted : items.isRetracted,
        //     retractedOn : items.retractedOn,
        //     isApproved : items.isApproved
        // })
    },
    APPROVED_OVERTIME(state, items){
        const index = state.employeeFiledOvertime.findIndex((e) => e.employeeFiledOvertimeId === items.employeeFiledOvertimeId)
        // Object.assign(state.employeeFiledOvertime[index], {isDraft: items.isDraft, remarks: items.remarks})
        // Object.assign(state.employeeFiledOvertime[index], items)

        const a = state.employeeFiledOvertime[index].approversOTs.findIndex((a) => a.approverId === items.approverId)
        Object.assign(state.employeeFiledOvertime[index].approversOTs[a], {
            isUnread : items.isUnread, 
            isApproved: items.isApproved, 
            approvedOn : items.approvedOn, 
            isRetracted : items.isRetracted
        })
    },
    DENIED_OVERTIME(state, items){
        const index = state.employeeFiledOvertime.findIndex((e) => e.employeeFiledOvertimeId === items.employeeFiledOvertimeId)
        // Object.assign(state.employeeFiledOvertime[index], {isDraft: items.isDraft, remarks: items.remarks})

        const a = state.employeeFiledOvertime[index].approversOTs.findIndex((a) => a.approverId === items.approverId)
        Object.assign(state.employeeFiledOvertime[index].approversOTs[a], {
            isUnread : items.isUnread, 
            isDenied: items.isDenied, 
            deniedOn : items.deniedOn, 
            isRetracted : items.isRetracted, 
            comments: items.comments
        })
    },
    REVISED_OVERTIME(state, items){
        const index = state.employeeFiledOvertime.findIndex((e) => e.employeeFiledOvertimeId === items.employeeFiledOvertimeId)
        // Object.assign(state.employeeFiledOvertime[index], {isDraft: items.isDraft, remarks: items.remarks})

        const a = state.employeeFiledOvertime[index].approversOTs.findIndex((a) => a.approverId === items.approverId)
        Object.assign(state.employeeFiledOvertime[index].approversOTs[a], {
            isUnread : items.isUnread, 
            isRevised: items.isRevised, 
            forRevisionOn : items.forRevisionOn, 
            isRetracted : items.isRetracted, 
            comments: items.comments
        })
    },
}